<ng-container *ngIf="solutionEvents && currentSolutionEvent ; else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
      <div class="cell shrink">
        <span (click)="previousSolutionEvents()"
              [ngClass]="{'c-light-gray': isFirstSolutionEvents(),
                          'c-medium-gray': !isFirstSolutionEvents()}"
              [ngStyle]="{'pointer-events': isFirstSolutionEvents() ? 'none' : 'auto'}"
              class="cursor-hover fas fa-chevron-circle-left margin-r-xs"></span>
        <span class="c-dark-gray margin-r-xs"
              style="font-weight: 500">
          {{'widget.latest-events.solution-name.'.concat(currentSolutionEvent.eventSolutionName) | translate}}
        </span>
        <span (click)="nextSolutionEvents()"
              [ngClass]="{'c-light-gray': isLastSolutionEvents(),
                          'c-medium-gray': !isLastSolutionEvents()}"
              [ngStyle]="{'pointer-events': isLastSolutionEvents() ? 'none' : 'auto'}"
              class="cursor-hover fas fa-chevron-circle-right"></span>
      </div>
    </div>
  </div>
  <div class="card-body padding-t-l padding-h-l event-widget-container"
       style="min-height: 345px;">
    <ng-container *ngFor="let eventsByDate of this.currentSolutionEvent.eventsByDate | keyvalue">
      <app-widget-event-item [eventDate]="eventsByDate.key"
                             [events]="eventsByDate.value"
                             [locale]="userContext.locale"
                             (eventSubscribed)="onTrackEventSubscribeAction($event)">
      </app-widget-event-item>
    </ng-container>

  </div>
  <div class="card-footer" style="height: unset">
  </div>
</ng-container>
<ng-template #noData>
  <app-widget-message [message]="'widget.latest-events.no-data'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>
